import React from 'react';
import {
  DescriptionOutlined,
  PeopleAltOutlined,
  PermIdentity,
  PriorityHighOutlined,
  SettingsOutlined,
  Storefront,
} from '@mui/icons-material';
import './profileLayout.css';
import GlobalSidebar from '../Global Sidebar/GlobalSidebar';
const iconSx = { color: '#ffffff' };
const manageTabList = [
  {
    title: 'Manage Your Account',
    tabs: [
      {
        iconSource: <PermIdentity sx={iconSx} />,
        title: 'User Details',
        navigateTo: '/my-account/user-details',
        bgColor: '#FF9201',
      },
      {
        iconSource: <Storefront sx={iconSx} />,
        title: 'Firm Details',
        navigateTo: '/my-account/firm-details',
        bgColor: '#FF9201',
      },
      {
        iconSource: <PeopleAltOutlined sx={iconSx} />,
        title: 'Staff Details',
        navigateTo: '/my-account/employee-details',
        bgColor: '#FF9201',
        isCheckOnboarding: true,
      },
      {
        iconSource: <DescriptionOutlined sx={iconSx} />,
        title: 'Profilers',
        bgColor: '#FF9201',
        showOptions: true,
        options: [
          {
            title: 'Business Profiler',
            navigateTo: '/my-account/business-profiler',
            bgColor: '#FF9201',
            isCheckOnboarding: true,
          },
          {
            title: 'Know you Better',
            navigateTo: '/my-account/know-you-better',
            bgColor: '#FF9201',
            isCheckOnboarding: true,
          },
        ],
      },
      {
        iconSource: <SettingsOutlined sx={iconSx} />,
        title: 'Change Credentials',
        navigateTo: '/my-account/change-credentials',
        bgColor: '#FF9201',
        lastTab: true,
      },
    ],
  },
];
const helpTabList = [
  {
    title: 'Need any Help?',
    tabs: [
      {
        iconSource: <PriorityHighOutlined sx={iconSx} />,
        title: 'FAQ',
        bgColor: '#FF9201',
        navigateTo: '/my-account/faq',
      },
      {
        iconSource: <DescriptionOutlined sx={iconSx} />,
        title: 'Contact Us & Policies',
        bgColor: '#FF9201',
        lastTab: true,
        navigateTo: '/my-account/contact-us-and-policies',
      },
    ],
  },
];

const MyAccountSideBar = () => {
  return <GlobalSidebar sections={[...manageTabList, ...helpTabList]} />;
};

export default MyAccountSideBar;
